import { render, staticRenderFns } from "./dropdown_value_collapsed.vue?vue&type=template&id=3bc31368&"
import script from "./dropdown_value_collapsed.vue?vue&type=script&lang=js&"
export * from "./dropdown_value_collapsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dropdown_value_collapsed.vue"
export default component.exports